import React from "react";

function FilteredResultsContainer(props) {
  return (
    <section className={`${props.itemType.toLowerCase()}`}>
      <ol className="collection collection-container">
        <li className="item item-container">
          <div className="attribute">Name</div>
          <div className="attribute">Title</div>
          <div className="attribute">Department</div>
          <div className="attribute">Phone</div>
          {props.isAuthed ? (
            <React.Fragment>
              <div className="attribute">Cell Phone</div>
            </React.Fragment>
          ) : (
            undefined
          )}
          <div className="attribute">Email</div>
        </li>
        {props.children}
      </ol>
    </section>
  );
}

export default FilteredResultsContainer;
